// extracted by mini-css-extract-plugin
export var actions = "Code-module--actions--61f65";
export var atTopPage = "Code-module--atTopPage--b2def";
export var ctaSection = "Code-module--ctaSection--ac72c";
export var extendedMenuSection = "Code-module--extendedMenuSection--255cd";
export var globalSearch = "Code-module--globalSearch--4c3e3";
export var languageSwitcher = "Code-module--languageSwitcher--6d9ef";
export var logoSection = "Code-module--logoSection--7fc06";
export var mobileCascadeMenu = "Code-module--mobileCascadeMenu--ed54c";
export var mobileCascadeMenuHolder = "Code-module--mobileCascadeMenuHolder--14196";
export var mobileMenu = "Code-module--mobileMenu--79288";
export var scrolling = "Code-module--scrolling--5ce23";
export var tkAktivGrotesk = "Code-module--tk-aktiv-grotesk--99180";
export var tkAktivGroteskCondensed = "Code-module--tk-aktiv-grotesk-condensed--cb612";
export var tkAktivGroteskExtended = "Code-module--tk-aktiv-grotesk-extended--ea07a";
export var tkAktivGroteskThin = "Code-module--tk-aktiv-grotesk-thin--41d99";
export var tkNeuzeitGrotesk = "Code-module--tk-neuzeit-grotesk--1c346";
export var tkNeuzeitGroteskCondensed = "Code-module--tk-neuzeit-grotesk-condensed--db531";
export var tkNeuzeitGroteskExtraConden = "Code-module--tk-neuzeit-grotesk-extra-conden--93460";
export var topMenuSection = "Code-module--topMenuSection--a16fa";
export var wrapper = "Code-module--wrapper--974a3";